import { createSelector } from "reselect";
import { getProjectById } from "./selector.projects.jsx";
import { getTaskById } from "./selector.tasks.jsx";
import { getLoggedUser } from "./selector.users.jsx";

export const getCanLoggedUserChangeBillableStatus = createSelector(
  (state, { projectId }) => getProjectById(state, projectId),
  getLoggedUser,
  (project, loggedUser) => {
    if (!project || !loggedUser || project.get("budget_type") === "not_billable") {
      return false;
    }

    // logged user is Owner
    if (loggedUser.get("class") === "Owner") {
      return true;
    }

    // logged user is Project leader or financial manager
    if (loggedUser.get("id") === project.get("leader_id") || loggedUser.isMemberFinancialManager()) {
      return true;
    }

    return loggedUser.get("class") === "Member" && project.get("members_can_change_billable");
  }
);

const getTrackingObjectParent = (state, { parentType, parentId }) => {
  if (parentType === "Task") {
    return getTaskById(state, parentId);
  }

  return getProjectById(state, parentId);
};

export const getParentBillableStatus = createSelector(
  getTrackingObjectParent,
  (parent) => !!(parent && parent.get("is_billable"))
);
